import React, { useEffect } from 'react';

import { Route, Switch, useHistory } from 'react-router-dom';

import { ShowHideHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { EnginesCatalog } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { useLogger } from '@hooks';
import { ROUTES, useNavigation } from '@navigation';
import { useFetchRetrieveContext } from '@services';
import { useIsOperator } from '@store';

import { FormPostRedirect } from './components/formPostRedirect';
import { GLOBAL_LOADER } from './components/globalLoader';

export const App: React.FC = (): JSX.Element => {
	const logger = useLogger();
	const { success } = useFetchRetrieveContext();
	const isOperator = useIsOperator();
	const { navigate, exit } = useNavigation();
	const history = useHistory();

	useEffect(() => {
		if (window.location.pathname === '/') {
			if (success) {
				navigate('intro');
			}
			if (isOperator) {
				navigate('accessDenied');
			}
		}
	}, [navigate, success, isOperator]);

	logger('App');

	useEffect(() => {
		return history.listen(() => {
			if (history.action === 'POP') {
				ShowHideHelper.show(GLOBAL_LOADER);
				exit();
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [history.action]);

	return (
		<>
			{(success !== undefined || isOperator) && (
				<Switch>
					<Route exact path={ROUTES.requestContact}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('requestContact', {})}
					</Route>
					<Route exact path={ROUTES.serviceError}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('serviceError', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionPaymentOptions}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionPaymentOptions', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionSelectAccount}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionSelectAccount', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionTermsAndConditionsBank}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionTermsAndConditionsBank', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionResumeAndAuthorization}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionResumeAndAuthorization', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionConclusion}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionConclusion', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionCorporateData}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionCorporateData', {})}
					</Route>
					<Route exact path={ROUTES.subscriptionIntegratorData}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('subscriptionIntegratorData', {})}
					</Route>

					<Route exact path={ROUTES.intro}>
						{EnginesCatalog.getInstance(EnginesCatalog).getPrismEngine().instantiatePrism('intro', {})}
					</Route>
					<Route exact path={ROUTES.accessDenied}>
						{EnginesCatalog.getInstance(EnginesCatalog)
							.getPrismEngine()
							.instantiatePrism('accessDenied', {})}
					</Route>
					<Route exact path={ROUTES.root}>
						{EnginesCatalog.getInstance(EnginesCatalog).getPrismEngine().instantiatePrism('_root', {})}
					</Route>
				</Switch>
			)}
			<FormPostRedirect />
		</>
	);
};
